import React, { FC } from 'react';
import {
  DailyProfitCardSkeleton,
  KeyMetricsLayout,
  ProfitTargetCardSkeleton,
  UnrealizedProfitCardSkeleton,
  WeeklyProfitCardSkeleton,
} from './components';

export const KeyMetricsLoading: FC = () => {
  return (
    <KeyMetricsLayout>
      <DailyProfitCardSkeleton />
      <UnrealizedProfitCardSkeleton />
      <WeeklyProfitCardSkeleton />
      <ProfitTargetCardSkeleton />
    </KeyMetricsLayout>
  );
};
